var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Component, Prop, Vue } from 'vue-property-decorator';
import GraduationProfileSelect from '@/components/GraduationProfileSelect/GraduationProfileSelect.vue';
import i18n from '@/i18n';
let SelectGraduationProfileDialog = class SelectGraduationProfileDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.payload = {
            graduationProfile: '',
            disableExistingGoals: false,
        };
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    initialize() {
        this.isLoading = true;
        this.reset(); // Make sure to reset the payload
        if (this.selectedGraduationProfile) {
            this.payload.graduationProfile = this.selectedGraduationProfile.uuid;
        }
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onClose() {
        this.$emit('close');
    }
    onSubmit() {
        if (!this.isValid) {
            return;
        }
        this.$emit('submitted', this.payload);
    }
    // #endregion
    // #region Class methods
    reset() {
        this.payload.graduationProfile = '';
        this.payload.disableExistingGoals = false;
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get isValid() {
        return !!this.payload.graduationProfile && this.payload.graduationProfile.length > 0;
        // return true;
    }
};
__decorate([
    Prop({ default: i18n.tc('Select graduation profile') }),
    __metadata("design:type", String)
], SelectGraduationProfileDialog.prototype, "title", void 0);
__decorate([
    Prop({ default: i18n.tc('Assign a new graduation profile and override or keep existing profiles.') }),
    __metadata("design:type", String)
], SelectGraduationProfileDialog.prototype, "description", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], SelectGraduationProfileDialog.prototype, "selectedStudent", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_b = typeof Record !== "undefined" && Record) === "function" ? _b : Object)
], SelectGraduationProfileDialog.prototype, "selectedGraduationProfile", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", String)
], SelectGraduationProfileDialog.prototype, "selectedArea", void 0);
SelectGraduationProfileDialog = __decorate([
    Component({
        components: {
            GraduationProfileSelect,
        },
    })
], SelectGraduationProfileDialog);
export default SelectGraduationProfileDialog;
// #endregion
// #region Constants
// #endregion
